<template>
    <div class="mt-36px pb-30px">
        <div class="flex flex-col justify-center items-center text-black text-24px font-700 mb-30px">
            {{ $t('stripe.subscription_title') }}
            <small class="gray text-18px text-center font-500 mt-10px">
                {{ $t('stripe.subscription_subtitle') }}
            </small>
        </div>
        <div v-if="success == 1" class="main-width bg-subscription-green_light rounded-6px 
            mx-auto h-56px pl-20px
            flex items-center gap-14px mb-10px border-1 border-subscription-green border-solid">
            <i i-app-check w-20px h-20px />
            <div class="text-14px font-400 text-subscription-green_dark">
                {{ $t('stripe.payment_success') }}
            </div>
        </div>
        <div v-if="success == 2" class="main-width bg-subscription-red_light rounded-6px 
            mx-auto h-56px pl-20px
            flex items-center gap-14px mb-10px border-1 border-subscription-red border-solid">
            <i i-subscription-warning w-20px h-20px />
            <div class="text-14px font-400 text-subscription-red_dark">
                {{ $t('stripe.payment_failed') }}
            </div>
        </div>
        <div v-if="pay_link && !success" class="main-width mx-auto  d-flex gap-10px items-center justify-between blue-bg rounded-6px h-80px p-14px  border-[#1E40AF80] border-1">
            <div class="d-flex gap-20px items-center">
                <i i-subscription-info w-20px h-20px />
                <div class="text-14px font-400 light-blue">
                    {{ $t('stripe.trial_expired') }}
                </div>
            </div>
            <a :href="pay_link" target="_blank"
                class="no-underline text-14px font-700 green-bg text-white rounded-4px w-230px h-43px d-flex justify-center items-center">
                {{ $t('stripe.renew_plan') }} {{ old_product_name }}
            </a>
        </div>
        <div v-if="is_paid == 1">
            <div
                class="bg-white rounded-18px p-24px flex flex-col gap-18px main-width mx-auto border-1 border-gray-light-color box-shadow">
                <div class="blue text-18px font-700">
                    {{ $t('stripe.active_plan_label') }}
                </div>
                <div class="d-flex items-center justify-between pr-30px">
                    <div
                        class="w-258px h-56px d-flex justify-between items-center gap-18px border-1 border-primary-color rounded-6px p-18px">
                        <div class="primary text-20px font-800 uppercase">
                            {{ subscription_details.product_name }}
                        </div>
                        <div v-if="subscription_details.in_trial"
                            class="w-48px h-16px d-flex justify-center items-center rounded-7px primary-bg text-white text-12px font-800">
                            TRIAL
                        </div>
                    </div>
                    <div v-if="subscription_details.start_date" class="d-flex flex-col gap-6px items-start" :class="{'flex-1 ml-5': subscription_details.by_admin}">
                        <span class="gray text-11px font-700">{{ $t('stripe.started_label') }}</span>
                        <span class="text-14px font-400 blue">{{ subscription_details.start_date }}</span>
                    </div>
                    <div v-if="!subscription_details.is_cancelled && subscription_details.end_date" class="d-flex flex-col gap-6px items-start">
                        <span class="gray text-11px font-700">{{ $t('stripe.next_payment_label') }}</span>
                        <span class="text-14px font-400 blue">{{ subscription_details.end_date }}</span>
                    </div>
                    <div v-else-if="subscription_details.cancel_at" class="d-flex flex-col gap-6px items-start">
                        <span class="gray text-11px font-700">Koniec</span>
                        <span class="text-14px font-400 blue">{{ subscription_details.cancel_at }}</span>
                    </div>
                    <div v-if="subscription_details.billing_cycle" class="d-flex flex-col gap-6px items-start">
                        <span class="gray text-11px font-700">Platba</span>
                        <span class="text-14px font-400 blue">{{ getPaymentType(subscription_details.billing_cycle)
                        }}</span>
                    </div>
                    <div v-if="subscription_details.price" class="d-flex flex-col gap-6px items-start">
                        <span class="gray text-11px font-700">Cena</span>
                        <span class="text-14px font-400 blue">{{ get_plan_price_by_invoice }}</span>
                    </div>
                </div>
                <div v-if="subscription_details.by_admin" class="d-flex gap-10px items-center justify-between blue-bg rounded-6px h-75px p-14px">
                    <div class="d-flex gap-10px items-center">
                        <i i-subscription-info w-20px h-20px />
                        <div class="text-14px font-400 light-blue">
                            {{ $t('stripe.admin_created') }}
                        </div>
                    </div>
                </div>
                <div v-else class="d-flex gap-10px items-center justify-between blue-bg rounded-6px h-75px p-14px">
                    <div class="d-flex gap-10px items-center">
                        <i i-subscription-info w-20px h-20px />
                        <div v-if="!subscription_details.is_cancelled && subscription_details.in_trial" class="text-14px font-400 light-blue">
                            {{ $t('stripe.trial_active') }}
                            <span class="font-700">{{ subscription_details.product_name }} TRIAL</span>
                            {{ $t('stripe.trial_days', {days: subscription_details.trial_period}) }}
                            {{ subscription_details.trial_end }}
                        </div>
                        <div v-if="subscription_details.is_cancelled" class="text-14px font-400 light-blue">
                            {{ $t('stripe.sub_cancels') }} {{ subscription_details.cancel_at }}
                        </div>
                        <div v-if="!subscription_details.in_trial && !subscription_details.is_cancelled"
                            class="text-14px font-400 light-blue">
                            {{ $t('stripe.sub_active') }}
                            <span class="font-700">{{ subscription_details.product_name }}</span>{{ $t('stripe.sub_next_payment') }}
                            {{ subscription_details.end_date }}
                        </div>
                    </div>
                    <a href="/admin/subscriptions/customer-portal" target="_blank"
                        class="no-underline text-14px font-700 green-bg text-white rounded-4px w-170px h-43px d-flex justify-center items-center">
                        {{ $t('stripe.manage_subscription') }}
                    </a>
                </div>
            </div>
        </div>
        <div v-if="subusers_count > 0 && is_paid != 1 && !subscription_details.by_admin && !session_id" class="main-width mx-auto d-flex gap-10px items-center justify-between blue-bg rounded-6px h-75px p-14px border-[#1E40AF80] border-1">
            <div class="d-flex gap-10px items-center">
                <i i-subscription-info w-20px h-20px />
                <div class="text-14px font-400 light-blue">
                    {{ $t('stripe.subusers_info', {count: subusers_count}) }} 
                    <span class="font-700">
                        {{ subusers_count > 5 ? $t('stripe.plan_big_team') : $t('stripe.plan_small_team') }}
                    </span>
                </div>
            </div>
        </div>
        <stripe-price-plan 
            :active-plan="subscription_details.product_name" 
            :payment-type="subscription_details.billing_cycle"
            :is_paid="is_paid"
            :user_id="user_id"
            :is_logged_in="is_logged_in"
            :subscription_status="subscription_details.status"
            :user_invoice_details="user_invoice_details"
            :is_invoice_details_filled="is_invoice_details_filled"
            :plan="plan"
            location="admin" />

        <div v-if="is_paid == 1"
            class="bg-white rounded-18px p-24px flex flex-col gap-18px main-width mx-auto mt-17px border-1 border-gray-light-color box-shadow">
            <div class="blue text-18px font-700">
                {{ $t('stripe.invoices_title') }}
            </div>
            <div v-if="subscription_invoices.length > 0" class="d-flex flex-col gap-11px">
                <div class="d-flex gap-10px items-center">
                    <span class="flex-1 gray text-10px font-400">{{ $t('stripe.invoice_date_col') }}</span>
                    <span class="flex-1 gray text-10px font-400 ml-10px">Cena</span>
                    <span class="flex-1 gray text-10px font-400 ml-10px">{{ $t('stripe.invoice_num_col') }}</span>
                    <span class="flex-2"></span>
                </div>
                <div class="d-flex flex-col border-1 border-gray-light-color rounded-6px border-b-gray-child">
                    <div v-for="(invoice, index) in subscription_invoices" :key="index"
                        class="">
                        <div v-if="invoice.invoice_number" 
                            @click="downloadInvoice(invoice.path)"
                            class="d-flex gap-10px items-center cursor-pointer p-16px">
                            <span class="flex-1 blue text-12px font-400">{{ formatDate(invoice.created_at) }}</span>
                            <span class="flex-1 blue text-12px font-400">{{ formatPrice(invoice.price) }}</span>
                            <span class="flex-1 blue text-12px font-400 underline">{{
                                invoice.invoice_number }}</span>
                            <div class="flex-2 cursor-pointer d-flex justify-end items-center">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7 1V9M7 9L4 6M7 9L10 6M2 13H12"
                                        stroke="#9598A7" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="d-flex flex-col gap-11px">
                {{ $t('stripe.no_invoices') }}
            </div>
            <div class="d-flex gap-10px items-center ">
                <a v-if="!subscription_details.is_cancelled" href="/admin/subscriptions/customer-portal-cancel"
                    target="_blank"
                    class="no-underline d-flex w-170px h-43px justify-center items-center rounded-4px border-gray-color gray text-15px font-700 cursor-pointer mt-10px">
                    {{ $t('stripe.cancel_sub') }}
                </a>
                <a v-else href="/admin/subscriptions/customer-portal-plans" target="_blank"
                    class="no-underline d-flex w-170px h-43px justify-center items-center rounded-4px border-gray-color gray text-15px font-700 cursor-pointer mt-10px">
                    {{ $t('stripe.renew_sub') }}
                </a>
                <div 
                    @click="openInvoiceDetailsModal"
                    class="no-underline d-flex w-200px h-43px justify-center items-center rounded-4px border-gray-color gray text-15px font-700 cursor-pointer mt-10px">
                    {{ $t('stripe.change_billing') }}
                </div>
            </div>
        </div>

        <div
            v-else-if="subscription_invoices.length > 0"
            class="bg-white rounded-18px p-24px flex flex-col gap-18px main-width mx-auto mt-17px border-1 border-gray-light-color box-shadow">
            <div class="blue text-18px font-700">
                {{ $t('stripe.invoices_title') }}
            </div>
            <div class="d-flex flex-col gap-11px">
                <div class="d-flex gap-10px items-center">
                    <span class="flex-1 gray text-10px font-400">{{ $t('stripe.invoice_date_col') }}</span>
                    <span class="flex-1 gray text-10px font-400 ml-10px">Cena</span>
                    <span class="flex-1 gray text-10px font-400 ml-10px">{{ $t('stripe.invoice_num_col') }}</span>
                    <span class="flex-2"></span>
                </div>
                <div class="d-flex flex-col border-1 border-gray-light-color rounded-6px border-b-gray-child">
                    <div v-for="(invoice, index) in subscription_invoices" :key="index"
                        class="">
                        <div v-if="invoice.invoice_number" 
                            @click="downloadInvoice(invoice.path)"
                            class="d-flex gap-10px items-center cursor-pointer p-16px">
                            <span class="flex-1 blue text-12px font-400">{{ formatDate(invoice.created_at) }}</span>
                            <span class="flex-1 blue text-12px font-400">{{ formatPrice(invoice.price) }}</span>
                            <span class="flex-1 blue text-12px font-400 underline">{{
                                invoice.invoice_number }}</span>
                            <div class="flex-2 cursor-pointer d-flex justify-end items-center">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7 1V9M7 9L4 6M7 9L10 6M2 13H12"
                                        stroke="#9598A7" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <subscription-offer-alert
            v-if="trial_alert"
            :open-modal="trial_alert"
            :trial_alert="trial_alert"
            :pay_link="pay_link"
            :old_product_name="old_product_name"
        />

        <InvoiceDetails 
            :openModal="invoice_details_modal" 
            :user_invoice_details="user_invoice_details" 
            :not_for_payment="not_for_payment"
            @closeModal="closeInvoiceDetailsModal"
            @save="saveInvoiceDetails"
            :invoice_details_alert="invoice_details_alert"
        />
    </div>
</template>

<script>
import moment from 'moment';
import SubscriptionOfferAlert from "./components/SubscriptionOfferAlert.vue";
import InvoiceDetails from "./components/InvoiceDetails.vue";
export default {
    components: {
        SubscriptionOfferAlert,
        InvoiceDetails
    },
    props: [
        'type', 
        'product', 
        'subscription_details', 
        'subscription_invoices', 
        'subscription_products', 
        'is_paid', 
        'user_id', 
        'is_logged_in',
        'session_id',
        'subusers_count',
        'success',
        'trial_alert',
        'pay_link',
        'old_product_name',
        'user_invoice_details',
        'is_invoice_details_filled',
        'invoice_details_alert'
    ],
    data() {
        return {
            invoice_details_modal: false,
            plan: null,
            not_for_payment: true
        }
    },
    mounted() {
        this.createSubscription();
    },
    created() {
        if(this.invoice_details_alert == 1){
            let plan = JSON.parse(localStorage.getItem('plan'));
            if(plan){
                this.not_for_payment = false;
                this.plan = plan;
            }
            this.invoice_details_modal = true;
        }
    },
    computed: {
        get_plan_price_by_invoice(){
            if(this.subscription_invoices.length > 0){
                return this.formatPrice(this.subscription_invoices[0].price);
            }
            return "0.00 €";
        }
    },
    methods: {
        formatDate(date) {
            return moment(date).format('DD.MM.YYYY');
        },
        formatPrice(price) {
            return price.replace(',', '.') + ' €';
        },
        getPaymentType(type) {
            if (type == 'monthly') {
                return this.$t('stripe.period_monthly')
            } else if (type == 'yearly') {
                return this.$t('stripe.period_yearly')
            }
        },
        async createSubscription() {
            if (this.session_id && this.user_id && this.success == 1) {
                await axios.post("/api/stripe/create-subscription", {
                    session_id: this.session_id,
                    user_id: this.user_id,
                    send_email: true
                }).then((response) => {
                });
                window.location.href = "/admin/subscriptions/dashboard";
            }
        },
        downloadInvoice(path) {
            window.open(`/stripe/invoices/download-file?path=${encodeURIComponent(path)}`, '_blank');
        },
        openInvoiceDetailsModal() {
            this.invoice_details_modal = true;
        },
        closeInvoiceDetailsModal() {
            this.invoice_details_modal = false;
        },
        saveInvoiceDetails(invoice_details) {
            this.user_invoice_details = invoice_details;
            this.not_for_payment = false;
            this.invoice_details_modal = false;
            let plan = JSON.parse(localStorage.getItem('plan'));
            if(plan){
                this.plan = plan;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.main-width {
    width: 920px;
}

.gray {
    color: #9598A7;
}

.border-gray-color {
    border: 1px solid #9598A7;
}

.primary {
    color: #F93C34;
}

.blue {
    color: #212541;
}

.green {
    color: #2ED8B6;
}

.green-bg {
    background-color: #2ED8B6;
}

.light-blue {
    color: #1E40AF;
}

.blue-bg {
    background-color: #EFF6FF;
}

.primary-bg {
    background-color: #F93C34;
}

.border-primary-color {
    border: 1px solid #F93C34;
}

.border-gray-light-color {
    border: 1px solid #E5E7EB;
}

.border-b-gray-child div:not(:last-child) {
    border-bottom: 1px solid #E5E7EB;
}

.box-shadow {
    box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.05);
}

.flex-1 {
    flex: 1;
}

.flex-2 {
    flex: 2;
}
</style>